import { getIsCypressRunning } from "constants/constants";
import CookieConsent from "react-cookie-consent";

export default function CookieConsentComponent({
  debug = false,
}: {
  debug?: boolean;
}) {
  // disable while running e2e tests -- unable to reliably clicking this in e2e test login script, and it blocks other elements
  return getIsCypressRunning() ? null : (
    <CookieConsent debug={debug} acceptOnScroll={true}>
      This website uses cookies to enhance the user experience. See our{" "}
      <a href="https://raven.ai/privacy-policy/" style={{ color: "#ffffff" }}>
        Privacy Policy
      </a>
      {" for more."}
    </CookieConsent>
  );
}
